"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
function render(_ctx, _cache, $props, $setup, $data, $options) {
    var _component_Transfer = vue_1.resolveComponent("Transfer");
    return (vue_1.openBlock(), vue_1.createElementBlock("div", null, [
        (_ctx.show)
            ? (vue_1.openBlock(), vue_1.createElementBlock("div", {
                key: 0,
                class: vue_1.normalizeClass(["forward", [_ctx.isH5 ? 'forward-h5' : '']]),
                ref: "dialog"
            }, [
                vue_1.createVNode(_component_Transfer, {
                    title: "转发",
                    list: _ctx.list,
                    isSearch: false,
                    isH5: _ctx.isH5,
                    isCustomItem: true,
                    resultShow: true,
                    onSubmit: _ctx.handleForWordMessage,
                    onCancel: _ctx.toggleShow
                }, {
                    left: vue_1.withCtx(function (_a) {
                        var data = _a.data;
                        return [
                            vue_1.renderSlot(_ctx.$slots, "left", { data: data }, undefined, true)
                        ];
                    }),
                    right: vue_1.withCtx(function (_a) {
                        var data = _a.data;
                        return [
                            vue_1.renderSlot(_ctx.$slots, "right", { data: data }, undefined, true)
                        ];
                    }),
                    _: 3
                }, 8, ["list", "isH5", "onSubmit", "onCancel"])
            ], 2))
            : vue_1.createCommentVNode("", true)
    ]));
}
exports.render = render;
